<template>

    <div class="bg-light p-1 text-secondary small top-bar">
        <div class="container">
            <div class="d-flex justify-content-between align-items-center">
                <div class="d-none d-xl-block">
                    <i class="bi bi-check2 text-primary"></i>
                    &nbsp;
                    Produkte von über 30 Lieferanten auf einen Blick
                    &nbsp;&nbsp;&nbsp;
                    <i class="bi bi-check2 text-primary"></i>
                    &nbsp;
                    Sonderkonditionen für DENTAGEN-Mitglieder
                    &nbsp;&nbsp;&nbsp;
                    <i class="bi bi-check2 text-primary"></i>
                    &nbsp;
                    Zentralregulierung
                </div>
                <!--                    <div>
                                        +++ Alle DENTAGEN Vorteile +++ <a href="https://www.dentagen.de/mitglied-werden/" target="_blank" class="link-dark">Mitglied werden</a>
                                    </div>-->
                <div>
                    <a href="https://www.dentagen.de" class="btn btn-sm btn-outline-primary fw-bold" target="_blank">
                        <i class="bi bi-box-arrow-up-right"></i>
                        {{ __('DENTAGEN') }}
                    </a>
                    <a href="https://mdr.dentagen.de" class="btn btn-sm btn-primary text-white fw-bold" target="_blank">
                        <i class="bi bi-box-arrow-up-right"></i>
                        {{ __('EasyMDR') }}
                    </a>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        props: [],
    }
</script>